var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 12.5c0 1.529.275 2.994.777 4.348L12.5 17.935l11.723-1.087c.502-1.354.777-2.819.777-4.348 0-1.53-.275-2.994-.777-4.348L12.5 7.065.777 8.152A12.5 12.5 0 0 0 0 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24.223 8.152C22.456 3.392 17.875 0 12.5 0S2.544 3.392.777 8.152zM.777 16.848C2.544 21.608 7.125 25 12.5 25s9.956-3.392 11.723-8.152z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "es_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })))));
};
export default SvgEs;